<template>
  <div>
    <!-- //^ ^--------------查看/新增/编辑的对话框-------------^ ^ -->
    <el-dialog
      :title="title"
      :visible.sync="dialog.visible"
      append-to-body
      :modal-append-to-body="false"
      @closed="closed"
      :close-on-click-modal="true"
      width="40%"
    >
      <div>
        <!-- 表单 -->
        <el-form
          ref="form"
          :disabled="dialog.disabled"
          :model="form"
          :rules="rules"
          label-width="150px"
        >
          <el-form-item label="插件名称：" prop="name">
            <el-input
              style="width: 250px"
              clearable
              v-model="form.name"
              placeholder="请输入插件名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="渠道选择：" prop="channelId">
            <el-radio-group v-model="form.channelId">
              <el-radio label="0">全部渠道</el-radio>
              <el-radio label="1">指定渠道</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.channelId === '1'" label="">
            <el-input
              type="textarea"
              @focus="handleClick()"
              v-model="form.appidFilterNames"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="key：" prop="code">
            <el-input
              v-model="form.code"
              placeholder="请输入key"
              style="width: 250px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 保存-取消 -->
      <span v-show="!dialog.disabled" slot="footer" style="flex-end">
        <el-button size="small" @click="hide">取 消</el-button>
        <el-button size="small" type="primary" @click="confirm"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <channel-popups
      :isAppendToBody="true"
      :modelIsAppendToBody="false"
      :app-id="form.appidFilterList"
      :visible.sync="showPopups"
      @comfirm="handleConfirm"
      :multiple="false"
    ></channel-popups>
  </div>
</template>

<script>
import Message from "@/components/Message";
import ChannelPopups from "@/components/channel-popups";
import { addPluginsGroup, editPluginsGroup } from "@/api/pluginManage/index";
import { removeEmpty } from "@/util/filters";
export default {
  name: "WebSassAdd",
  computed: {
    title() {
      return this.dialog.title;
    },
  },
  components: {
    ChannelPopups,
  },
  data() {
    return {
      /** 渠道选择框的显隐 */
      showPopups: false,
      /** 表单 */
      form: {
        /** 指定渠道id */
        appidFilterList: "",
        /** 渠道类型 */
        channelId: "0",
        /** 渠道名称 */
        appidFilterNames: "",
        id: "",
        code: "",
        channelName: "",
      },
      /** 表单验证规则 */
      rules: {
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        code: [{ required: true, message: "请输入key", trigger: "blur" }],
        channelId: [
          { required: true, message: "请选择渠道类型", trigger: "blur" },
        ],
      },
      dialog: {
        visible: false,
        title: "",
        disabled: false,
      },
    };
  },
  methods: {
    // ^ ^--------------对话框内的事件-------------^ ^
    /** 渠道选择框 */
    handleClick() {
      this.showPopups = true;
    },
    /** 确认渠道选择 */
    handleConfirm(data) {
      console.log("渠道选择的数据", data);
      const { appId, nameStr } = data;
      this.form.appidFilterList = appId;
      this.form.appidFilterNames = nameStr;
    },
    /** 确认的事件 */
    confirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          /** 验证通过 */
          if (this.dialog.title === "创建插件组") {
            const params = removeEmpty({
              name: this.form.name,
              code: this.form.code,
              channelId:
                this.form.channelId === "1" ? this.form.appidFilterList : "0",
              channelName:
                this.form.channelId === "1"
                  ? this.form.appidFilterNames
                  : "全部渠道",
            });
            console.log("创建插件组传递接口的参数", params);
            const { data } = await addPluginsGroup(params);
            if (data.code === 200) {
              Message.success("创建成功");
              /** 通知列表刷新 */
              this.$emit("reload");
            }
          } else {
            const params = removeEmpty({
              id: this.form.id,
              name: this.form.name,
              code: this.form.code,
              channelId:
                this.form.channelId === "1" ? this.form.appidFilterList : "0",
              channelName:
                this.form.channelId === "1"
                  ? this.form.appidFilterNames
                  : "全部渠道",
            });
            console.log("编辑插件组传递接口的参数", params);
            const { data } = await editPluginsGroup(params);
            if (data.code === 200) {
              Message.success("编辑成功");
              /** 通知列表刷新 */
              this.$emit("reload");
            }
          }
          this.hide();
        } else {
          /** 验证失败 */
          Message.error("请检查表单");
        }
      });
    },
    show(row) {
      console.log("拿到的row", row);
      if (row) {
        const params = { ...row };
        /** 修正渠道类型 */
        if (String(params.channelId) === "0") {
          params.channelId = "0";
        } else {
          /** 修正渠道选择对话框内的渠道id 和 渠道名称 */
          params.appidFilterList = String(params.channelId);
          params.appidFilterNames = params.channelName;
          params.channelId = "1";
        }

        this.dialog.title = "编辑插件组";
        this.form = params;
        console.log("编辑回填的数据", this.form);
      } else {
        this.dialog.title = "创建插件组";
      }
      this.dialog.visible = true;
    },
    hide() {
      this.dialog.visible = false;
      this.$emit("reload");
    },
    closed() {
      console.log("closed");
      /** 清理表单数据 */

      if (this.$refs.form) {
        this.form = {
          id: "",
          name: "",
          goods: "",
          time: "",
          period: "",
          price: "",
          show: "",
          status: "",
          remark: "",
        };
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      console.log("form", this.$refs.form);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  padding-right: 50px !important;
}

::v-deep .el-textarea__inner {
  padding-right: 55px !important;
  max-height: 100px !important;
}
</style>